import { map } from 'ramda';
import React, { FC } from 'react';
import { useNotificatorRenderer } from '../../../utils/hooks/useNotificator';
import styles from './NotificationContainer.scss';
import { IOuter } from './NotificationContainer.types';

export const NotificationContainer: FC<IOuter> = () => {
  const { notifications } = useNotificatorRenderer();

  return (
    <div className={styles.notificationsContainer}>
      {map(
        ({ id, NotificationComponent, dismiss }) => (
          <div key={id} className={styles.notification}>
            <NotificationComponent onClose={dismiss} />
          </div>
        ),
        notifications,
      )}
    </div>
  );
};
